(ns common.schema.entities.counterparty-diligence.company
  (:require
   [common.schema.entities.counterparty-diligence.common :as counterparty-diligence-common]
   [common.schema.entities.counterparty-diligence.templates.registry :as template-registry]
   [common.schema.entities.counterparty-diligence.util :as counterparty-diligence-util]
   [common.schema.schema-utils :as su]))

(def screening-status-options
  (->>
   [{:value :screening-status/active
     :label "Active"}
    {:value :screening-status/inactive
     :label "Inactive"}]
   (mapv (fn [{:keys [value] :as opt}]
           (assoc opt :key value)))))

(def template-options
  (->> template-registry/legal-entity-templates
       (mapv (fn [[template-id template]]
               {:key   template-id
                :value template-id
                :label (:template/template-name template)}))))

(def schema
  (concat
   (su/text-simple-field :company-counterparty-diligence/company-name
                         "Company name"
                         {:mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use-disabled})

   (su/keyword-field :company-counterparty-diligence/template
                     "Template"
                     template-options
                     {:mandatory-config         :mandatory/always
                      :system-required?         true
                      :system-semantics
                      su/user-provided-system-required-field-semantics
                      :default-field-visibility :in-use-disabled
                      :option-filter-fn         counterparty-diligence-util/template-option-filter})

   (su/keyword-field :company-counterparty-diligence/screening-status
                     "Screening status"
                     screening-status-options
                     {:default-field-visibility :in-use})

   counterparty-diligence-common/schema))
